import { callBackendApi } from "../../../components/service/axios";

export const getUserGroupDetails = async (userGroupUniqueName) => {
  return await callBackendApi("get", `/bff/user-group-detail/${userGroupUniqueName}`);
};

export const patchExcludedMembers = async (userGroupUniqueName, payload) => {
  return await callBackendApi(
    "patch",
    "/bff/user-groups/" + userGroupUniqueName + "/membership/exclude",
    payload
  );
};
